import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { ColumnsType } from "antd/lib/table/interface";
import CmrStore from "../stores/cmr/CmrStore";
import DateRange from "../components/declarants/dateRange";
import { DateRangeDate, IObjectMap } from "../interfaces/common";
import Search from "../components/declarants/search";
import Table from "../components/common/Table";
import TableWrapper from "../components/declarants/tableWrapper";
import updateSortingAndFiltersOfColumns from "../helpers/filters";
import { CMR_ACTIVE_COLUMNS, CMR_ORDER_COLUMNS } from "../constants/settings";
import COLUMNS from "../components/tables/cmrTable/config";
import CreateCmr from "../components/buttons/cmr/createCmr";
import Settings from "../components/declarants/Settings";
import UpdateCmr from "../components/forms/CmrForm/updateCmr";
import { CAN_CREATE_AND_EDIT_CMR } from "../constants/authorize";
import Authorize from "../components/Authorize";
import Card from "../components/Card/Card";
import CollapseHeader from "../components/CollapseHeader";
import SettingsStore from "../stores/SettingsStore";
import UserStore from "../stores/UserStore";
import RefreshButton from "../components/buttons/RefreshButton";

const cmrStore = new CmrStore();

const onLoadHandler = (
  parameters?: IObjectMap,
  forceUpdate?: boolean
): void => {
  cmrStore.load(parameters || {}, forceUpdate || false);
};

const CmrPage: React.FC<{
  settingsStore: SettingsStore;
  userStore: UserStore;
}> = ({ userStore, settingsStore }) => {
  useEffect(() => {
    cmrStore.initialLoad();
  }, []);

  useEffect(() => {
    settingsStore.setColumns(
      updateSortingAndFiltersOfColumns(
        userStore.authorizedOnly(COLUMNS) || COLUMNS,
        cmrStore.parameters as IObjectMap
      ),
      CMR_ORDER_COLUMNS,
      CMR_ACTIVE_COLUMNS
    );
  }, [
    settingsStore,
    userStore,
    settingsStore.isEnabledReorder,
    cmrStore.parameters,
  ]);

  return (
    <>
      <CollapseHeader>
        <CreateCmr modalFooter={null} />
        <Settings reorderable />
      </CollapseHeader>
      <Card>
        <Card.Header justifyContent="start">
          <DateRange
            store={cmrStore}
            startDate={cmrStore.parameters.start_date as DateRangeDate}
            endDate={cmrStore.parameters.end_date as DateRangeDate}
          />
          <Search store={cmrStore} />
          <RefreshButton refresh={cmrStore} />
        </Card.Header>
        <TableWrapper enableScrollBar={settingsStore?.isEnabledScrollbar}>
          <Table
            columns={settingsStore.activeColumns as ColumnsType<object>}
            data={cmrStore.data}
            onLoad={onLoadHandler}
            hasMoreItems={!cmrStore.isLoadingTableData && cmrStore.hasMoreItems}
            isLoading={cmrStore.isLoadingTableData}
            settingsStore={settingsStore}
          />
        </TableWrapper>
      </Card>
      <Authorize permission={CAN_CREATE_AND_EDIT_CMR}>
        <UpdateCmr />
      </Authorize>
    </>
  );
};

export default inject(({ store }) => ({
  settingsStore: store.settingsStore,
  userStore: store.userStore,
}))(observer(CmrPage));
